module.exports = __webpack_public_path__ + "img/icon_5_68.179aa1d8.png";